/* Fixed-width gutter track between the ImportedTrackData and QwireTracksFields columns:
   ResolverRow fills it with an empty spacer (so auto-placement doesn't shift fields into
   it) and TrackTitleSelect's copy control overhangs into it. A dedicated track (not a
   wider columnGap) keeps the QwireTracksFields <-> aliases gap untouched. */
export const RESOLVER_GUTTER_WIDTH = 32;

export const RESOLVER_GRID = {
  gridTemplateColumns: `1.05fr ${RESOLVER_GUTTER_WIDTH}px 1fr 1.55fr`,
  columnGap: 4,
} as const;

export const ROW_ACTION = {
  MATCH_EXISTING: 'match-existing',
  CREATE_NEW: 'create-new',
  LEAVE_UNMATCHED: 'leave-unmatched',
} as const;

export type RowAction = typeof ROW_ACTION[keyof typeof ROW_ACTION];

export const RESOLVER_ACTIONS = {
  ROWS_LOADED: 'rows/loaded',
  LIBRARY_SELECTED: 'row/librarySelected',
  LIBRARY_CREATED: 'row/libraryCreated',
  TRACK_SELECTED: 'row/trackSelected',
  TRACK_CREATED: 'row/trackCreated',
  USE_CHANGED: 'row/useChanged',
  DURATION_CHANGED: 'row/durationChanged',
  ROW_CLEARED: 'row/cleared',
  ALIAS_REMOVED: 'row/aliasRemoved',
  DIVISION_ALIAS_DELETED: 'divisionAlias/deleted',
} as const;
